import { Box, FormControl, IconButton, TextField } from '@material-ui/core'
import { ZoomInOutlined, ZoomOutOutlined } from '@material-ui/icons'

const STEP = 0.25
const MIN_VALUE = 0.25

type ZoomControlsProps = { zoom: number; setZoom: (zoom: number) => void }
export default function ZoomControls({ zoom, setZoom }: ZoomControlsProps) {
  return (
    <FormControl>
      <Box display='flex'>
        <IconButton color='secondary' onClick={() => setZoom(zoom + STEP)}>
          <ZoomInOutlined />
        </IconButton>
        <TextField
          label='Zoom'
          variant='outlined'
          value={zoom}
          style={{ width: 100 }}
          type='number'
          InputProps={{ inputProps: { min: MIN_VALUE, step: STEP } }}
          color='secondary'
          onChange={(e) => setZoom(parseFloat(e.target.value))}
        />
        <IconButton
          color='secondary'
          onClick={() => setZoom(Math.max(MIN_VALUE, zoom - STEP))}
        >
          <ZoomOutOutlined />
        </IconButton>
      </Box>
    </FormControl>
  )
}
